import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { INK } from '../../utils/commercialColors';

// CAC/LTV columns are intentionally absent: both require the `campaign`
// table from the product spec's §12, which is explicitly V2 scope and was
// never actually defined in the spec's own SQL (§14) despite §12
// describing its fields - see the backend's stats.ts comment for the
// full rationale.
export default function AcquisitionChannels({ channels }) {
  if (!channels) return null;

  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Canaux d'acquisition
      </Typography>
      <Box sx={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ textAlign: 'left', borderBottom: `1px solid ${INK.gridline}` }}>
              {['Canal', 'Clients', 'Conversion', 'Churn'].map((h) => (
                <th key={h} style={{ padding: '8px 12px', color: INK.muted, fontWeight: 500 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {channels.map((c) => (
              <tr key={c.channel} style={{ borderBottom: `1px solid ${INK.gridline}` }}>
                <td style={{ padding: '8px 12px', color: INK.primary, fontWeight: 600 }}>{c.channel}</td>
                <td style={{ padding: '8px 12px', fontVariantNumeric: 'tabular-nums' }}>{c.clients}</td>
                <td style={{ padding: '8px 12px', fontVariantNumeric: 'tabular-nums' }}>{c.conversion_pct}%</td>
                <td style={{ padding: '8px 12px', fontVariantNumeric: 'tabular-nums' }}>{c.churn_pct}%</td>
              </tr>
            ))}
            {channels.length === 0 && (
              <tr><td colSpan={4} style={{ padding: 16, textAlign: 'center', color: INK.muted }}>Aucune donnée</td></tr>
            )}
          </tbody>
        </table>
      </Box>
      <Typography variant="caption" sx={{ color: INK.muted, display: 'block', mt: 1 }}>
        CAC et LTV arrivent avec les campagnes (V2)
      </Typography>
    </Paper>
  );
}
